import { DeviceEntryProps } from '@ixicare/resources';
import { SortAccessor } from '../types';

export type DeviceSortAccessor = SortAccessor<DeviceEntryProps>;

const ownerAccessor: DeviceSortAccessor = (d) => {
  const owner: any = d.owner;
  if (!owner) return null;
  return `${owner.firstName} ${owner.lastName}`.trim() || null;
};

const updatedOnAccessor: DeviceSortAccessor = (d) => {
  const updatedOn = d.status?.updatedOn;
  return updatedOn ? new Date(updatedOn).getTime() : null;
};

const deviceCommonSortAccessors: Record<string, DeviceSortAccessor> = {
  id: (d) => d.id,
  mac_address: (d) => d.macAddress,
  description: (d) => d.description ?? null,
  sw_version: (d) => d.swVersion ?? null,
  battery_level: (d) => d.batteryLevel ?? null,
  updated_on: updatedOnAccessor,
  state: (d) => d.billingState ?? null,
};

export const wearableSortAccessors: Record<string, DeviceSortAccessor> = {
  ...deviceCommonSortAccessors,
  owner: ownerAccessor,
  device_type: (d) => d.deviceType ?? null,
  phone_number: (d) => d.phoneNumber ?? null,
  imei_number: (d) => d.imeiNumber ?? null,
};

export const wristwatchSortAccessors: Record<string, DeviceSortAccessor> = {
  ...wearableSortAccessors,
  fw_version: (d) => d.fwVersion ?? null,
};

export const buttonSortAccessors: Record<string, DeviceSortAccessor> = {
  ...deviceCommonSortAccessors,
  emergency_button: (d) => (d.subType != null ? 'Active' : 'Inactive'),
  room_number: (d) => d.roomNumber ?? null,
};

export const eviewSortAccessors: Record<string, DeviceSortAccessor> = {
  ...deviceCommonSortAccessors,
  owner: ownerAccessor,
  phone_number: (d) => d.phoneNumber ?? null,
  imei_number: (d) => d.imeiNumber ?? null,
};

export const apiSortAccessors: Record<string, DeviceSortAccessor> = {
  ...deviceCommonSortAccessors,
  api_identifier: (d) => (d as any).apiIdentifier ?? null,
};
